import { QRCodeSVG } from "qrcode.react";
import { ShareLink } from "./guest-account";
import { t } from "../i18n";

// Opening the link or scanning its code shows the account's profile with Add,
// whether or not username search finds it. Until it is first shared there is
// no code yet, so the link appears once the server has made one.
export function ProfileLink({
  code,
  failed,
  disabled,
  onRetry,
  onReset,
}: {
  code: string | null | undefined;
  failed: boolean;
  disabled: boolean;
  onRetry: () => void;
  onReset: () => void;
}) {
  if (!code)
    return failed ? (
      <p className="form-error" role="alert">
        {t("تعذر تجهيز رابط حسابك.")}{" "}
        <button className="quiet-button" onClick={onRetry}>
          {t("إعادة المحاولة")}
        </button>
      </p>
    ) : (
      <div
        className="profile-link-skeleton"
        role="status"
        aria-label={t("جارٍ تجهيز رابط حسابك")}
      >
        <i />
        <b />
      </div>
    );
  const link = new URL(`/add/${code}`, location.origin).href;
  return (
    <div className="profile-link">
      {/* Scanners read dark modules on a light tile most reliably. */}
      <div className="profile-qr">
        <QRCodeSVG
          value={link}
          size={168}
          level="M"
          bgColor="#edf1ef"
          fgColor="#151817"
          title={t("رمز QR لرابط حسابك")}
        />
      </div>
      <ShareLink
        label={t("رابط حسابك")}
        link={link}
        text={t("أضفني إلى أصدقائك على رنّة")}
        inputId="profile-link"
      >
        <button
          className="quiet-button profile-link-reset"
          disabled={disabled}
          onClick={onReset}
        >
          {t("إعادة تعيين الرابط")}
        </button>
      </ShareLink>
    </div>
  );
}
